import React, { Component } from "react";

import styles from "./ListItems.css";

interface Props {
  icon: JSX.Element;
  firstLine: null | string | JSX.Element;
  secondLine: null | string | JSX.Element;
  thirdLine?: null | string | JSX.Element;
}

export const ListItem = ({ icon, firstLine, secondLine, thirdLine }: Props) => (
  <div className={styles.sidebar_infos_destiny}>
    {icon}
    <div className={styles.container_line}>
      {firstLine && <div className={styles.title}>{firstLine}</div>}
      <div className={styles.line}>{secondLine}</div>
      {thirdLine && <div className={styles.line}>{thirdLine}</div>}
    </div>
  </div>
);
